namespace Solovis.ModuleLoader {    
    
    export var modules: any = [];

    export var moduleNameToModuleMap: any = {};

    export var _moduleNameToAttemptedDownloadMap: any = {};

    export var _standardModuleDefinitionsLoaded: boolean = false;
    export var _standardModuleDefinitionsCacheKey: string = "Solovis.ModuleLoader._cachedStandardModuleDefinitions";

    // NOTE: Set to true to enable logging on ModuleLoader.
    export var _log: boolean = false;

    export var _disableCache: boolean = (Solovis as any).Info && (Solovis as any).Info.devMode;


    /**
     * Used to register module names that have been preloaded.
     */
    export function reportLoadedModuleName(moduleName: string): void {          
        var module = ModuleLoader.moduleNameToModuleMap[moduleName];
        if (module) {
            module.isLoaded = true;
        }
        else {
            module = {
                name: moduleName,
                isLoaded: true
            };

            ModuleLoader.modules.push(module);
            ModuleLoader.moduleNameToModuleMap[moduleName] = module;
        }
    }

    /**
     * Add module definitions to registry. Each module definition should have
     * name, url, dependsOn, and optional classList property. dependsOn should
     * be array of other module names that are needed.
     * @param moduleList - array of module definitions
     */
    export function registerModules(moduleList): void {           
        $(moduleList).each(function (i, module: any) {
            if (!ModuleLoader.moduleNameToModuleMap[module.name]) {
                ModuleLoader.modules.push(module);
                ModuleLoader.moduleNameToModuleMap[module.name] = module;
            }
            else {
                var existingModule = ModuleLoader.moduleNameToModuleMap[module.name];
                for (var key in module) {
                    existingModule[key] = module[key];
                }
            }
        });
    }

    export function isModuleLoaded(moduleName: string): boolean {
        var module = ModuleLoader.moduleNameToModuleMap[moduleName];
        if (module && module.isLoaded) {
            return true;
        }
        else {
            return false;
        }
    }

    export function modalEnsureModuleListLoaded(moduleList, callback): void {
        if (_.isEmpty(moduleList)) {
            if (callback) {
                callback();
            }
        }

        if (typeof moduleList == "string") {
            moduleList = [moduleList];
        }

        var unloadedModuleFound = false;
        for (var i = 0; i < moduleList.length; i++) {
            if (!ModuleLoader.isModuleLoaded(moduleList[i])) {
                unloadedModuleFound = true;
                break;
            }
        }

        if (unloadedModuleFound) {
            Solovis.Rpc.showWaitingDialog();
            ModuleLoader.loadModuleListByName(moduleList, function () {
                Solovis.Rpc.hideWaitingDialog();
                if (callback) {
                    callback();
                }
            });
        }
        else {
            if (callback) {
                callback();
            }
        }
    }

    export function loadModuleListByName(moduleNames: string[], callback: () => void): void {
        if (moduleNames && moduleNames.length > 0) {
            var unloadedModuleFound = false;
            for (var i = 0; i < moduleNames.length; i++) {
                if (!this.isModuleLoaded(moduleNames[i])) {
                    unloadedModuleFound = true;
                    break;
                }
            }

            if (unloadedModuleFound) {
                var expectedLoadCount = moduleNames.length;
                var loadCount = 0;

                var checkIfDone = function () {
                    if (loadCount == expectedLoadCount) {
                        if (ModuleLoader._log) { console.log("ModuleLoader.loadModuleListByName: module list loaded: " + JSON.stringify(moduleNames)); }
                        if (callback) {
                            callback();
                        }
                    }
                };

                $(moduleNames).each(function (i, moduleName: any) {
                    ModuleLoader.loadModuleByName(moduleName, function () {
                        loadCount++;
                        checkIfDone();
                    });
                });
            }
            else {
                // All modules already loaded.
                if (callback) {
                    callback();
                }
            }
        }
        else {
            if (callback) {
                callback();
            }
        }
    }


    export function loadModuleByName(moduleName: string, callback: () => void): void {
        if (ModuleLoader.isModuleLoaded(moduleName)) {
            if (callback) {
                callback();
            }            
        }
        else {
            ModuleLoader._ensureStandardModuleDefinitionsLoaded(function () {
                ModuleLoader._loadModuleByName(moduleName, callback);
            });
        }
    };


    export function _loadModuleByName(moduleName: string, callback: () => void): void {        
        var module = ModuleLoader.moduleNameToModuleMap[moduleName];
        if (!module) {
            if (!ModuleLoader._moduleNameToAttemptedDownloadMap[moduleName]) {
                var moduleDefinitionStatus: any = {
                    loadStarted: true,
                    callbackList: [ callback ]
                };
                ModuleLoader._moduleNameToAttemptedDownloadMap[moduleName] = moduleDefinitionStatus;

                // The callbackInvoker will re-process the callbacks for any component waiting on the module load.
                var callbackInvoker = function (success) {
                    $(moduleDefinitionStatus.callbackList).each(function (i, callbackEntry: any) {
                        try {
                            if (success) {
                                ModuleLoader._loadModuleByName(moduleName, callbackEntry);
                            }
                            else {
                                if (callbackEntry) {
                                    callbackEntry();
                                }
                            }
                        }
                        catch (ex) {
                            Solovis.log("callback from ModuleLoader.loadModuleByName threw exception.");
                            Solovis.log(ex);
                        }                        
                    });
                };

                Solovis.Rpc.invoke("~/ModuleLoader/GetModuleDefinition", { moduleName: moduleName },
                    function (response, success) {
                        moduleDefinitionStatus.loadFinished = true;

                        if (success) {                            
                            var moduleDef = response.result;

                            if (moduleDef) {
                                if (ModuleLoader._log) { console.log("ModuleLoader._loadModuleByName: module definition loaded: " + moduleName); }

                                ModuleLoader.registerModules([moduleDef]);
                                callbackInvoker(true);
                            }
                            else {
                                console.log("ModuleLoader._loadModuleByName: module load failed: " + moduleName);

                                moduleDefinitionStatus.loadFailed = true;
                                callbackInvoker(false);
                            }
                        }
                        else {
                            console.log("ModuleLoader._loadModuleByName: module load failed: " + moduleName);

                            moduleDefinitionStatus.loadFailed = true;
                            callbackInvoker(false);
                        }
                    });
            }
            else {
                var moduleDefinitionStatus = ModuleLoader._moduleNameToAttemptedDownloadMap[moduleName];

                if (moduleDefinitionStatus.loadFailed) {
                    Solovis.log("Unable to load module: " + moduleName);

                    // Unable to load module definition, so just call the callback which signifies we are done trying to load.
                    callbackInvoker(false);
                }
                else {                    
                    if (!moduleDefinitionStatus.loadFinished) {
                        // Add callback to the list of callbacks that will called upon completion of module load.
                        moduleDefinitionStatus.callbackList.push(callback);
                    }
                }
            }

            return;
        }

        if (module.isLoaded) {
            if (callback) {
                callback();
            }
        }
        else {
            if (!module.postLoadCallbacks) {
                // Initialize list of callbacks to call after module loading has finished.
                module.postLoadCallbacks = [];
            }

            if (callback) {
                module.postLoadCallbacks.push(callback);
            }

            if (!module.isLoadPending) {
                module.isLoadPending = true;

                var doImportScript = function () {
                    ModuleLoader._doImportScriptsAndStyles(
                        module,
                        function () {
                            if (ModuleLoader._log) { console.log("ModuleLoader._loadModuleByName: module loaded: " + moduleName); }

                            module.isLoaded = true;
                            module.isLoadPending = false;

                            $(module.postLoadCallbacks).each(function (i, postLoadCallbackMethod: any) {
                                postLoadCallbackMethod();
                            });
                        });
                };

                if (module.dependsOn && module.dependsOn.length > 0) {
                    var areAllDependenciesLoaded = function () {
                        for (var i = 0; i < module.dependsOn.length; i++) {
                            var dependencyName = module.dependsOn[i];
                            var dependsOnModule = ModuleLoader.moduleNameToModuleMap[dependencyName];
                            if (!dependsOnModule || !dependsOnModule.isLoaded) {
                                return false;
                            }
                        }

                        return true;
                    };

                    var doImportScriptOnce = _.once(doImportScript);

                    // Try to load all dependencies and then call doImport when all are loaded.
                    $(module.dependsOn).each(function (i, dependencyName: any) {
                        ModuleLoader._loadModuleByName(dependencyName, function () {
                            if (areAllDependenciesLoaded()) {                                
                                doImportScriptOnce();
                            }
                        });
                    });
                }
                else {
                    // No dependencies.
                    doImportScript();
                }
            }
        }
    }


    export function loadModuleForClass(className: string, callback: () => void): void {
        var moduleFound = false;

        $(ModuleLoader.modules).each(function (i, module: any) {
            // TODO: Consider having a table that maps classes to modules.
            if (!moduleFound) {
                if (module.classList) {
                    if (_.contains(module.classList, className)) {
                        ModuleLoader.loadModuleByName(module.name, callback);
                        moduleFound = true;
                    }
                }
            }
        });

        if (!moduleFound) {
            if (callback) {
                // Callback is expected to called exactly once after the load attempt finishes.
                // In this case, it is obvious the class hasn't been loaded.
                callback();
            }
        }
    };

    export function _doImportScriptsAndStyles(module, callback: () => void): void {
        // This will load all scripts and styles and then invoke callback.

        if (ModuleLoader._log) {
            console.log("ModuleLoader._doImportScriptsAndStyles: starting actual module import: " + module.name);
        }        

        var expectedLoadCount = 0;
        var loadCount = 0;

        // Determine expected load count.

        if (module.styles) {
            $(module.styles).each(function (i, style) {
                expectedLoadCount++;
            });
        }

        if (module.scripts) {
            $(module.scripts).each(function (i, script) {
                expectedLoadCount++;
            });
        }

        // Actually load scripts and styles.

        var checkIfDone = function () {
            if (expectedLoadCount == loadCount) {                
                callback();
            }
        };

        if (module.styles) {
            $(module.styles).each(function (i, style: any) {
                Solovis.importStylesheet(style.url, function () {
                    loadCount++;
                    checkIfDone();
                });
            });
        }

        if (module.scripts) {            
            var scriptsToLoad = module.scripts.slice(0);

            var loadNextScript = function () {
                if (scriptsToLoad.length > 0) {
                    var script = scriptsToLoad[0];
                    scriptsToLoad = scriptsToLoad.slice(1);                                    

                    Solovis.importScript(script.url, function () {
                        loadCount++;
                        checkIfDone();

                        loadNextScript();
                    });
                }                
            };

            loadNextScript();
        }
    }


    export function _getLoadedModules(): any[] {
        var loadedModules = _.filter(ModuleLoader.modules, function (m: any) { return m.isLoaded; });
        return loadedModules;
    }


    export function _ensureStandardModuleDefinitionsLoaded(callback: () => void): void {
        var self = this;

        if (!this._standardModuleDefinitionsLoaded) {
            // See if we can just use cached standard module definitions from the same build.
            if (ModuleLoader._tryGetCachedStandardModuleDefinitions()) {
                if (ModuleLoader._log) { console.log("ModuleLoader: using cached standard module definitions"); }
                if (callback) {
                    callback();
                }
            }
            else {
                Solovis.Rpc.invoke(
                    "~/ModuleLoader/GetAllStandardModuleDefinitions",
                    {},
                    function (response, success) {
                        if (success) {
                            if (ModuleLoader._log) { console.log("ModuleLoader._ensureStandardModuleDefinitionsLoaded: all standard module definitions loaded"); }

                            var result = response.result;

                            ModuleLoader.registerModules(result.modules);
                            ModuleLoader._tryToCacheStandardModuleDefinitions(result);

                            self._standardModuleDefinitionsLoaded = true;
                        }

                        if (callback) {
                            callback();
                        }
                    });
            }
        }
        else {
            // Standard module definitions have already been retrieved.
            if (callback) {
                callback();
            }
        }
    }

    export function _tryToCacheStandardModuleDefinitions(modulesResult): boolean {
        if (typeof Storage == "undefined") {
            return false;
        }

        try {
            var cacheKey = ModuleLoader._standardModuleDefinitionsCacheKey;

            var moduleDefData = {
                savedAt: (new Date()).getTime(),
                buildId: modulesResult.buildId,
                modules: modulesResult.modules
            };

            var moduleDefDataJson = JSON.stringify(moduleDefData);

            window.localStorage.setItem(cacheKey, moduleDefDataJson);    
            return true;        
        }
        catch (ex) {
            console.log("ModuleLoader._tryToCacheStandardModuleDefinitions: saving cached module definitions failed.");
            console.log(ex);
            return false;
        }
    }

    export function _tryGetCachedStandardModuleDefinitions(): boolean {
        if (ModuleLoader._disableCache) {
            return false;
        }

        if (typeof Storage == "undefined") {
            return false;
        }

        try {
            var cacheKey = ModuleLoader._standardModuleDefinitionsCacheKey;

            var moduleDefDataJson = window.localStorage.getItem(cacheKey);
            if (moduleDefDataJson) {
                var moduleDefData = JSON.parse(moduleDefDataJson);

                if (moduleDefData.buildId == (Solovis as any).Info.buildId) {
                    ModuleLoader.registerModules(moduleDefData.modules);
                    ModuleLoader._standardModuleDefinitionsLoaded = true;
                    return true;
                }
            }
        }
        catch (ex) {
            console.log("ModuleLoader._tryGetCachedStandardModuleDefinitions: loading cached module definitions failed.");
            console.log(ex);
            return false;
        }

        return false;
    };
   
}

// Populate module list with modules that have already been loaded. _loadedModules would have been
// set on the server as the set of modules already included in the page.
if ((Solovis as any)._loadedModules) {
    $((Solovis as any)._loadedModules).each(function (i, modName: any) {
        Solovis.ModuleLoader.reportLoadedModuleName(modName);
    });
    delete (Solovis as any)._loadedModules;
}
    